import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";
import HeaderBar from "../../components/HeaderBar";
import Sidebar from "../../components/Sidebar";
import { useAuth } from "../../providers/AuthContext";
import { createManufacturer } from "../../api/Manufacturer";
import toast from "react-hot-toast";
import LoadingTablePage from "../LoadingTablePage";
import ConfirmationModal from "../../components/ConfirmationModal";
import ManufacturerForm from "../../components/manufacturer/ManufacturerForm";

const CreateManufacturerPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { customerPublicId } = location.state || {};
  const { getAccessToken } = useAuth(); 
  const navigate = useNavigate();
  const [loading] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [confirmState, setConfirmState] = useState({ isOpen: false, id: "" });  

  const [manufacturer, setManufacturer] = useState({
    manufacturerPublicId: "",
    manufacturerName: "",
  });

  const handleInputChange = (key, value) => {
    setHasChanges(true);
    setManufacturer((prev) => ({ ...prev, [key]: value }));
  };

const handleCreateManufacturer = async () => {
  const name = (manufacturer?.manufacturerName || "").trim();
  if (!name) {
    toast.error(t("manufacturer.nameRequired"));
    return;
  }

  const toastId = toast.loading(t("toast.creating", { entity: t("entity.manufacturer") }));
  try {
    const token = await getAccessToken();

    const manufacturerData = { manufacturerName: name };
    const res = await createManufacturer(manufacturerData, token);

    toast.success(t("toast.created", { entity: t("entity.manufacturer") }), { id: toastId });

    navigate(`/manufacturer/${res.manufacturerPublicId}`);
  } catch (error) {
    toast.error(
      error.response?.data?.message || t("toast.failedCreate", { entity: t("entity.manufacturer") }),
      { id: toastId }
    );
  }
};

    const handleBackClick = () => {
    if (hasChanges && customerPublicId) {
      setConfirmState((s) => ({ ...s, isOpen: true, title: t("confirm.discard"), confirm: () => { navigate(`/manufacturer/${customerPublicId}?tab=manufacturers`); } }));
    } else {
            if (navigate.length > 1) {
        navigate(-1);
      } else {
        navigate("/manufacturers");
      }
    }
  };

  return (
    <>
      <HeaderBar />
      <div className="flex flex-row w-full">
        <Sidebar />
        <main className="page">
          <div className="absolute inset-0 pointer-events-none">
            <LoadingTablePage title={t("pages.createManufacturer")} loading={loading} />
          </div>

          <div className={`${loading ? "loading" : ""} page-content`}>
            <div className="flex flex-row items-center pb-4">
              <button
                onClick={() => handleBackClick()}
                className="text-black flex"
              >
                <FontAwesomeIcon icon={faArrowLeft} className="w-4 pr-4" />
              </button>
              <h2 className="border-l border-mute-200 pl-4 ">{t("pages.createManufacturer")}</h2>
              <div className="flex gap-4 ml-auto">
                <button
                  className="btn btn-outline-primary"
                  onClick={() => handleBackClick()}
                >
                  {t("common.cancel")}
                </button>
                <button
                  className="btn btn-primary"
                  disabled={!manufacturer?.name && !hasChanges}
                  onClick={handleCreateManufacturer}
                >
                  {t("common.save")}
                </button>
              </div>
            </div>

            <div className=" px-4 py-8 shadow-lg rounded-md w-full">
                <ManufacturerForm 
                manufacturer={manufacturer} 
                handleInputChange={handleInputChange} 
                />             
            </div>
          </div>
        </main>
          <ConfirmationModal
          isOpen={confirmState.isOpen}
          title={confirmState.title ? confirmState.title : t("manufacturer.deleteManufacturer")}
          onClose={() => { setConfirmState((s) => ({ ...s, isOpen: false })) }}
          onConfirm={() => { setConfirmState((s) => ({ ...s, isOpen: false })); confirmState.confirm() }}
        />
      </div>
    </>
  );
};

export default CreateManufacturerPage;
